import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { SwitchCardConfiguration } from '../../models/switchCardConfiguration';

@Component({
    selector: 'bdo-switch-card',
    templateUrl: './switch-card.component.html',
    styleUrls: ['./switch-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SwitchCardComponent {
  @Input() configuration: SwitchCardConfiguration[];
  @Input() selectedTile: string;
  @Output() selected: EventEmitter<string> = new EventEmitter();

  onSelect(selectedTile: string) {
    this.selectedTile = selectedTile;
    this.selected.emit(selectedTile);
  }

}
